import React, { useState, useEffect } from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { toast } from "react-hot-toast";
import axios from "axios";
import API_BASE_URL from "../../../config/config.js";

const ModalElegirInstitution = ({
  open,
  onClose,
  idevent,
  idsport,
  selectedGrupo,
  selectedNroGrupo,
  selectedInstitution,
  setParticipantes,
  config,
  participantes,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredInstitutions, setFilteredInstitutions] = useState([]);

  /* ------------------------------------------------------------------ */
  /*  Cargar instituciones aún no asignadas a un grupo                  */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    const fetchFilteredInstitutions = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/getparticipantsregion`,
          {
            idevent: Number(idevent),
            idsport: Number(idsport),
            idtypephase: 1,
          }
        );

        // 1) Filtrar instituciones sin grupo
        const institutionsNotInGroups = response.data.filter(
          (p) => p.idgrupo == null
        );

        // 2) Ordenar: primero por posicion (si existe), luego los que no tienen posicion
        const sorted = institutionsNotInGroups.sort((a, b) => {
          const pa = a.posicion;
          const pb = b.posicion;
          // Ambos sin posicion ⇒ quedan en el mismo orden
          if (pa == null && pb == null) return 0;
          // Si A no tiene posicion va al final
          if (pa == null) return 1;
          // Si B no tiene posicion, A va primero
          if (pb == null) return -1;
          // Ambos tienen posicion ⇒ orden numérico ascendente
          return pa - pb;
        });

        setFilteredInstitutions(sorted);
      } catch (error) {
        console.error("Error fetching institutions", error);
      }
    };

    if (open) fetchFilteredInstitutions();
  }, [open, idevent, idsport]);


  /* ------------------------------------------------------------------ */
  /*  Limpiar selección (quitar participante del grupo)                 */
  /* ------------------------------------------------------------------ */
  const handleClearSearch = async () => {
    setSearchTerm("");

    try {
      await axios.patch(`${API_BASE_URL}/updateparticipant`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 1,
        idinstitution: selectedInstitution
          ? selectedInstitution.idinstitution
          : null,
        idgrupo: null,
        nro_grupo: null,
      });

      // Recargar lista de participantes
      const response = await axios.post(
        `${API_BASE_URL}/getparticipantsregion`,
        {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 1,
        }
      );

      setParticipantes(response.data);

      const institutionsNotInGroups = response.data.filter(
        (p) => p.idgrupo === null || p.idgrupo === undefined
      );
      setFilteredInstitutions(institutionsNotInGroups);

      onClose();
    } catch (error) {
      console.error("Error updating participant", error);
      toast.error("Error al limpiar la selección");
    }
  };

  /* ------------------------------------------------------------------ */
  /*  Asignar institución al grupo                                      */
  /* ------------------------------------------------------------------ */
  const handleSelectInstitution = async (idinstitution) => {
    try {
      // 197
      if (Number(idevent) === 197 && Number(idsport) !== 42) {
        /* -------- ① localizar al participante en la lista global -------- */
        const participante = participantes.find(
          (p) => p.Institution.idinstitution === idinstitution
        );
        if (!participante) {
          toast.error("No se encontró la institución seleccionada.");
          return;
        }

        /* -------- ② calcular la sub-posición dinámicamente ---------- */
        const { posicion } = participante;  // ej. 1, 2, 4, 5, ...
        if (posicion == null) {
          toast.error("La institución no tiene una posición definida.");
          return;
        }

        //  –  Construimos un array con todas las posiciones válidas,
        //     ordenadas de menor a mayor.
        const posicionesOrdenadas = participantes
          .map((p) => p.posicion)
          .filter((pos) => pos != null)
          .sort((a, b) => a - b);

        //  –  Encontramos el índice de nuestra posición dentro de ese array
        const idx = posicionesOrdenadas.indexOf(posicion);

        //  –  Cada fila son 3 posiciones: fila 1 = índices 0,1,2; fila 2 = 3,4,5; etc.
        const subPosicion = Math.floor(idx / 3) + 1;

        /* -------- ③ comparar con la fila destino (selectedNroGrupo) ------ */
        if (subPosicion !== Number(selectedNroGrupo)) {
          toast.error("Esta institución no puede ir en esta fila del grupo.");
          return; // abortar asignación
        }
      }

      /* ----------------------------------------------------------------- */
      /*  Si pasa la validación, se procede a actualizar en el back-end    */
      /* ----------------------------------------------------------------- */
      await axios.patch(`${API_BASE_URL}/updateparticipant`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 1,
        idinstitution,
        idgrupo: selectedGrupo,
        nro_grupo: selectedNroGrupo,
      });

      // Recargar participantes
      const response = await axios.post(
        `${API_BASE_URL}/getparticipantsregion`,
        {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 1,
        }
      );
      setParticipantes(response.data);

      // Filtrar instituciones aún no asignadas a grupo
      const institutionsNotInGroups = response.data.filter(
        (p) => p.idgrupo == null
      );
      setFilteredInstitutions(institutionsNotInGroups);

      onClose();
    } catch (error) {
      console.error("Error updating participant", error);
      toast.error("Error al asignar la institución");
    }
  };


  /* ------------------------------------------------------------------ */
  /*  Render                                                            */
  /* ------------------------------------------------------------------ */
  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
      open={open}
      onClose={onClose}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Sheet
        variant="outlined"
        sx={{
          width: "80%",
          maxWidth: 800,
          borderRadius: "md",
          p: 3,
          boxShadow: "lg",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <ModalClose variant="plain" sx={{ m: 1 }} />

        <Typography
          component="h2"
          id="modal-title"
          level="h4"
          fontWeight="lg"
          mb={1}
        >
          Lista de Instituciones
        </Typography>

        {/* Buscador + botón limpiar */}
        <div className="flex items-center mb-4">
          <input
            type="text"
            placeholder="Buscar institución por nombre o sigla..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none"
          />
          <CleaningServicesIcon
            className="cursor-pointer ml-2 hover:text-blue-500 hover:scale-110"
            onClick={handleClearSearch}
          />
        </div>

        {/* Tabla con todas las instituciones disponibles */}
        <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredInstitutions
                .filter(
                  (p) =>
                    p.Institution.name
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    p.Institution.abrev
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                )
                .map((p, idx) => (
                  <tr
                    key={idx}
                    className="cursor-pointer transition transform hover:bg-gray-200"
                    onClick={() =>
                      handleSelectInstitution(p.Institution.idinstitution)
                    }
                  >
                    {/* Nº + logo */}
                    <td className="px-2 py-3 whitespace-nowrap relative">
                      <div className="flex items-center">
                        <span className="absolute left-0 text-xs font-semibold">
                          {idx + 1}
                        </span>
                        <div className="relative">
                          {p.Institution.image_path ? (
                            <>
                              <img
                                src={`${p.Institution.path_base}${p.Institution.image_path}`}
                                alt="Logo"
                                className="w-10 h-10 rounded-full object-cover"
                                style={{
                                  minWidth: "40px",
                                  minHeight: "40px",
                                }}
                              />
                              {config.useBandera && (
                                <div
                                  className="absolute bottom-6 left-7 bg-gray-300"
                                  style={{
                                    width: "30px",
                                    height: "20px",
                                    transform: "scale(0.5)",
                                  }}
                                >
                                  <img
                                    src={p.Institution.country.img_path}
                                    alt="Bandera"
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="w-10 h-10 rounded-full bg-gray-200"></div>
                          )}
                        </div>
                      </div>
                    </td>

                    {/* Nombre y sigla */}
                    <td className="px-2 py-3 whitespace-normal">
                      {p.Institution.name}
                    </td>
                    <td className="px-2 py-3 whitespace-nowrap">
                      {p.Institution.abrev}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Sheet>
    </Modal>
  );
};

export default ModalElegirInstitution;
